<script setup lang="ts">
interface InfoCardProps {
  number: string
  title: string
  subtitle?: string
}

defineProps<InfoCardProps>()
</script>

<template>
  <div class="info-card">
    <span class="info-card__number">{{ number }}</span>
    <h2 class="info-card__title">{{ title }}</h2>
    <p class="info-card__subtitle">{{ subtitle }}</p>
  </div>
</template>

<style scoped>
.info-card {
  border: 1px solid #ccc;
  padding: 1.5rem;
  text-align: left;
  width: 23.875rem;
  height: 12.5rem;
  box-sizing: border-box;
}

.info-card__number {
  font-size: 0.9em;
  color: #888;
  margin-bottom: 5px;
  display: block;
}

.info-card__title {
  text-transform: uppercase;
  font-size: 1.2em;
  font-weight: 600;
  margin-bottom: 10px;
}

.info-card__subtitle {
  font-size: 1em;
  color: #555;
}
</style>
